import React, { ReactNode } from "react"
import { Box } from "@chakra-ui/react"
import { PASS_BUILDER_FIELD_WIDTH } from "./passBuilderTokens"

type Props = {
  children: ReactNode
  /** Indent to align with Value: row (static value fields) */
  indented?: boolean
  /** Override default field width (e.g. auxiliary columns) */
  width?: string
}

const PassBuilderFieldInput = ({ children, indented, width }: Props) => (
  <Box
    w={width ?? PASS_BUILDER_FIELD_WIDTH}
    minW={0}
    flexShrink={0}
    ml={indented ? "53px" : undefined}
  >
    {children}
  </Box>
)

export default PassBuilderFieldInput
